import { useEffect } from 'react';
/**
 * Calls `onOutsideClick` when a mousedown event occurs outside all provided refs.
 */
export function useOutsideClick(refs, isActive, onOutsideClick) {
    useEffect(() => {
        if (!isActive)
            return;
        const handler = (e) => {
            const target = e.target;
            const isInside = refs.some((ref) => ref.current && ref.current.contains(target));
            if (!isInside) {
                onOutsideClick();
            }
        };
        document.addEventListener('mousedown', handler);
        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [refs, isActive, onOutsideClick]);
}
